import { InitialState } from '../components/studyCreationGuide/components';
import { DragAndDropInstructions } from '../components/studyCreationGuide/components/dragAndDropInstructions';
import { DefineRegion } from '../components/studyCreationGuide/steps/step1/defineRegion';
import { UnderstandPrimaryMarket } from '../components/studyCreationGuide/steps/step2/understandPrimaryMarket';
import {
  GuideSteps,
  GuideStepsKeys,
  IsDropDownOpenMapper,
} from './studies.model';
import nls from '../nls/pt-BR.json';
import { BuildingLayouts } from '../components/studyCreationGuide/steps/step2/buildingLayouts';
import { UnderstandSecondaryMarket } from '../components/studyCreationGuide/steps/step3/understandSecondaryMarket';
import { LayoutsValuationPrimary } from '../components/studyCreationGuide/steps/step2/layoutsValuationPrimary';
import { LayoutsValuationSecondary } from '../components/studyCreationGuide/steps/step3/layoutsValuationSecondary';
import { CalculateVGV } from '../components/studyCreationGuide/steps/step4/calculateVGV';
import { VGVResponse } from '../components/studyCreationGuide/steps/step4/VGVResponse';
import { QualifyTargetAudience } from '../components/studyCreationGuide/steps/step5/qualifyTargetAudience';
import { CalculateInstallmentsPrimary } from '../components/studyCreationGuide/steps/step5/calculateInstallmentsPrimary';
import { CalculateInstallmentsSecondary } from '../components/studyCreationGuide/steps/step5/calculateInstallmentsSecondary';
import { QualifiedAudienceResponse } from '../components/studyCreationGuide/steps/step5/qualifiedAudienceResponse';
import { UnderstandTransactions } from '../components/studyCreationGuide/steps/step6/understandTransactions';
import { UnderstandMarketCycle } from '../components/studyCreationGuide/steps/step6/understandMarketCycle';
import { AbsorptionAndLiquidity } from '../components/studyCreationGuide/steps/step7/absorptionAndLiquidity';
import { AbsorptionAndLiquidityResponse } from '../components/studyCreationGuide/steps/step7/absorptionAndLiquidityResponse';

export const GUIDE_STEPS: GuideSteps = {
  initialState: {
    component: InitialState,
    canAdvance: true,
    nextStep: 'dragAndDropInstructions',
    previousStep: 'initialState',
    name: 'initialState',
  },
  dragAndDropInstructions: {
    component: DragAndDropInstructions,
    canAdvance: true,
    nextStep: 'defineRegion',
    previousStep: 'initialState',
    name: 'dragAndDropInstructions',
  },
  defineRegion: {
    step: 1,
    component: DefineRegion,
    canAdvance: false,
    nextStep: 'understandPrimaryMarket',
    previousStep: 'dragAndDropInstructions',
    hasCustomButtons: true,
    name: 'defineRegion',
  },
  understandPrimaryMarket: {
    step: 2,
    component: UnderstandPrimaryMarket,
    canAdvance: false,
    nextStep: 'buildingLayouts',
    previousStep: 'defineRegion',
    name: 'understandPrimaryMarket',
  },
  buildingLayouts: {
    step: 2,
    component: BuildingLayouts,
    canAdvance: false,
    nextStep: 'layoutsValuationPrimary',
    previousStep: 'understandPrimaryMarket',
    hasCustomButtons: true,
    name: 'buildingLayouts',
  },
  layoutsValuationPrimary: {
    step: 2,
    component: LayoutsValuationPrimary,
    canAdvance: true,
    nextStep: 'understandSecondaryMarket',
    previousStep: 'buildingLayouts',
    hasCustomButtons: true,
    name: 'layoutsValuationPrimary',
  },
  understandSecondaryMarket: {
    step: 3,
    component: UnderstandSecondaryMarket,
    canAdvance: false,
    nextStep: 'layoutsValuationSecondary',
    previousStep: 'layoutsValuationPrimary',
    hasCustomButtons: true,
    name: 'understandSecondaryMarket',
  },
  layoutsValuationSecondary: {
    step: 3,
    component: LayoutsValuationSecondary,
    canAdvance: true,
    nextStep: 'calculateVGV',
    previousStep: 'understandSecondaryMarket',
    hasCustomButtons: true,
    name: 'layoutsValuationPrimary',
  },
  calculateVGV: {
    step: 4,
    component: CalculateVGV,
    canAdvance: false,
    nextStep: 'VGVResponse',
    previousStep: 'layoutsValuationSecondary',
    hasCustomButtons: true,
    name: 'calculateVGV',
  },
  VGVResponse: {
    step: 4,
    component: VGVResponse,
    canAdvance: true,
    nextStep: 'qualifyTargetAudience',
    previousStep: 'calculateVGV',
    name: 'VGVResponse',
  },
  qualifyTargetAudience: {
    step: 5,
    component: QualifyTargetAudience,
    canAdvance: false,
    nextStep: 'calculateInstallmentsPrimary',
    previousStep: 'VGVResponse',
    name: 'qualifyTargetAudience',
  },
  calculateInstallmentsPrimary: {
    step: 5,
    component: CalculateInstallmentsPrimary,
    canAdvance: true,
    nextStep: 'calculateInstallmentsSecondary',
    previousStep: 'qualifyTargetAudience',
    hasCustomButtons: true,
    name: 'calculateInstallmentsPrimary',
  },
  calculateInstallmentsSecondary: {
    step: 5,
    component: CalculateInstallmentsSecondary,
    canAdvance: true,
    nextStep: 'qualifiedAudienceResponse',
    previousStep: 'calculateInstallmentsPrimary',
    hasCustomButtons: true,
    name: 'calculateInstallmentsSecondary',
  },
  qualifiedAudienceResponse: {
    step: 5,
    component: QualifiedAudienceResponse,
    canAdvance: true,
    nextStep: 'understandTransactions',
    previousStep: 'calculateInstallmentsSecondary',
    name: 'qualifiedAudienceResponse',
  },
  understandTransactions: {
    step: 6,
    component: UnderstandTransactions,
    canAdvance: false,
    nextStep: 'understandMarketCycle',
    previousStep: 'qualifiedAudienceResponse',
    name: 'understandTransactions',
  },
  understandMarketCycle: {
    step: 6,
    component: UnderstandMarketCycle,
    canAdvance: false,
    nextStep: 'absorptionAndLiquidity',
    previousStep: 'understandTransactions',
    hasCustomButtons: true,
    name: 'understandMarketCycle',
  },
  absorptionAndLiquidity: {
    step: 7,
    component: AbsorptionAndLiquidity,
    canAdvance: true,
    nextStep: 'absorptionAndLiquidityResponse',
    previousStep: 'understandMarketCycle',
    hasCustomButtons: true,
    name: 'absorptionAndLiquidity',
  },
  absorptionAndLiquidityResponse: {
    step: 7,
    component: AbsorptionAndLiquidityResponse,
    canAdvance: true,
    nextStep: 'initialState',
    previousStep: 'absorptionAndLiquidity',
    hasCustomButtons: true,
    name: 'absorptionAndLiquidityResponse',
  },
};

export const IS_DROPDOWN_OPEN: IsDropDownOpenMapper = {
  0: false,
  1: false,
  2: false,
  3: false,
  4: false,
  5: false,
  6: false,
  7: false,
  8: false,
  9: false,
};

export const API_CURRENT_STEP_KEYS_MAPPER: {
  [key in ApiKeys]: GuideStepsKeys;
} = {
  start: 'defineRegion',
  region: 'understandPrimaryMarket',
  primary_market: 'understandSecondaryMarket',
  secondary_market: 'calculateVGV',
  vgv_primary_secondary: 'qualifyTargetAudience',
  perfil_socio: 'understandTransactions',
  transactioned_market_cycle: 'absorptionAndLiquidity',
  absorption_liquidity: 'absorptionAndLiquidityResponse',
};

export type ApiKeys =
  | 'start'
  | 'region'
  | 'primary_market'
  | 'secondary_market'
  | 'vgv_primary_secondary'
  | 'perfil_socio'
  | 'transactioned_market_cycle'
  | 'absorption_liquidity';

export const EXPANDED_AREA_RADIUS = 2500;

export const GOOD_PHASING = 3;

export const MAX_BUILDING_LAYOUTS = 6;
